import { createAsyncThunk } from '@reduxjs/toolkit';
import { Logger } from 'simple-logging-lib';
import { RequestStatus } from '../../../interface';
import { updateOptinsStatus, getOptinsStatus } from '../services/optins.service';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import { DataFetchingError } from '../../../errors/DataFetchingError';
import { getPortalId } from '../../../utils/getPortalId';
import { selectOptinsStatus } from '../selectors/optins.selectors';
export const getOptinsStatusThunk = createAsyncThunk('optins/getOptinsStatus', async (optinName, {
  rejectWithValue
}) => {
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  const portalId = getPortalId();
  if (!portalId) {
    return rejectWithValue();
  }
  try {
    const response = await getOptinsStatus(optinName, portalId);
    return response;
  } catch (error) {
    const requestError = error;
    logger.error(new DataFetchingError('Failed to get optins status', {
      statusCode: requestError.status,
      cause: requestError
    }));
    return rejectWithValue();
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const optinsStatus = selectOptinsStatus(state);
    return optinsStatus.status === RequestStatus.IDLE;
  }
});
export const updateOptinsStatusThunk = createAsyncThunk('optins/updateOptinsStatus', async ({
  optinName,
  status
}, {
  rejectWithValue,
  getState,
  dispatch
}) => {
  var _optinsStatus$data;
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  const portalId = getPortalId();
  if (!portalId) {
    return rejectWithValue();
  }
  const state = getState();
  const optinsStatus = selectOptinsStatus(state);
  const currentActionAt = (_optinsStatus$data = optinsStatus.data) === null || _optinsStatus$data === void 0 ? void 0 : _optinsStatus$data.stateActionAt;
  if (!currentActionAt) {
    return rejectWithValue();
  }
  try {
    await updateOptinsStatus(optinName, status, portalId, currentActionAt);
  } catch (error) {
    const requestError = error;
    logger.error(new DataFetchingError('Failed to update optins status', {
      statusCode: requestError.status,
      cause: requestError
    }));
    return rejectWithValue();
  }

  // At the end we dispatch a new GET request to obtain the optins new currentActionAt
  void dispatch(getOptinsStatusThunk(optinName));
}, {
  condition: (_, {
    getState
  }) => {
    var _optinsStatus$data2;
    const state = getState();
    const optinsStatus = selectOptinsStatus(state);
    return optinsStatus.status === RequestStatus.SUCCESS && ((_optinsStatus$data2 = optinsStatus.data) === null || _optinsStatus$data2 === void 0 ? void 0 : _optinsStatus$data2.stateActionAt) !== undefined;
  }
});